import firebaseConfig from "./config";
import app from "firebase/compat/app";

if (!app.apps.length) {
  app.initializeApp(firebaseConfig);
}

export default app;
